module.exports = __webpack_public_path__ + "bg_menu.png?28792126827034bcf94543998515db72";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_menu.png
// module id = 84
// module chunks = 0